import styled from 'styled-components';

export const Container = styled.div`
	flex-grow: 1;
	max-width: 15%;
	min-width: 25rem;
	overflow-y: auto;
	border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
`;

export const Inner = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;
`;

export const CategorySection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const CardContainer = styled.div<{ $isSelected: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.75rem;
	padding: 0.75rem;
	border-radius: 0.25rem;
	border: 1px solid
		${({ theme, $isSelected }) =>
			$isSelected ? theme.v3.colors.blue[6] : theme.v3.colors.gray[4]};
	cursor: pointer;
`;

export const CardBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	flex: 1;
	min-width: 0;
`;

export const BadgeColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 0.25rem;
	flex-shrink: 0;
`;
